import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-61b64416")
const _hoisted_1 = ["title"]
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_contract_form_card = _resolveComponent("contract-form-card")!
  const _component_base_card = _resolveComponent("base-card")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["add-contract", { adding: _ctx.adding }])
  }, [
    (!_ctx.adding)
      ? (_openBlock(), _createElementBlock("dig-ui-icon", {
          key: 0,
          type: "add",
          class: "add-button",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.adding = true)),
          title: _ctx.$t('add')
        }, null, 8, _hoisted_1))
      : _createCommentVNode("", true),
    (_ctx.adding)
      ? (_openBlock(), _createBlock(_component_base_card, {
          key: 1,
          class: "form"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_contract_form_card, {
              title: _ctx.$t('Contract.new'),
              onValidate: _cache[1] || (_cache[1] = ($event: any) => (_ctx.addContract($event))),
              onCancel: _cache[2] || (_cache[2] = ($event: any) => (_ctx.adding = false)),
              contract: _ctx.contract
            }, null, 8, ["title", "contract"])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ], 2))
}